import { render, staticRenderFns } from "./ForceLogin.vue?vue&type=template&id=064d6408&"
import script from "./ForceLogin.vue?vue&type=script&lang=js&"
export * from "./ForceLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports